import { useState, } from "react";
import { Col, Card, Input, Form, DatePicker, Select, InputNumber } from "antd";
import classes from "../Pages.module.css";

import dayjs from "dayjs";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons"; // Import eye icons

const { Option } = Select;

const DataField = (props) => {
  const [passwordVisible, setPasswordVisible] = useState(false); // State for toggling password visibility

  const capitalizeFirstLetter = (text) => {
    return text
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const disabledDate = (current) => {
    // Disable days after today (can't select future dates)
    return current && current > dayjs().endOf("day");
  };

  const renderInput = () => {
    if (props.param === "item_code" || props.param === "item_code_retype") {
      return (
        <Input.Password
          value={props.value || ""}
          bordered={true}
          onChange={(e) => props.handleChange(e, props.param, props.id)}
          style={{
            width: "100%",
            float: "left",
            backgroundColor: "white",
            color: "#1777C4",
            fontWeight: "bold",
            boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
          }}
          visibilityToggleIcon={
            passwordVisible ? <EyeOutlined /> : <EyeInvisibleOutlined />
          }
          onClick={() => setPasswordVisible(!passwordVisible)}
        />
        
      );
    }
    if (props.param === "expiry_days") {
      // Handle expiry days as a number input
      return (
        <InputNumber
          value={props.value !== undefined && props.value !== null ? props.value : 0} // Default value as 0
          onChange={(value) => props.handleChange(value, props.param)}
          bordered={true}
          style={{
            width: "100%",
            backgroundColor: "white",
            color: "#1777C4",
            fontWeight: "bold",
            boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
          }}
        />
      );
    }
    return (
      <Input
        placeholder="Enter here"
        value={props.value || ""}
        bordered={true}
        onChange={(e) => props.handleChange(e, props.param, props.id)}
        style={{
          width: "100%",
          float: "left",
          backgroundColor: "white",
          color: "#1777C4",
          fontWeight: "bold",
          boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
        }}
      />
    );
  };

  const renderCard = () => {
    if (props.param === "item_code" || props.param === "item_code_retype") {
      // For password and retype password fields, show masked text with eye icon
      return (
        <p className={classes["Label"]}>
          {props.name}{" "}
          <span className={classes["Data"]}>
            {props.value ? "******" : null}{" "}
            <EyeOutlined style={{ cursor: "pointer", color: "#1777C4" }} onClick={() => setPasswordVisible(!passwordVisible)} />
          </span>
        </p>
      );
    }

    if (props.param === "expiry_days") {
      // For expiry days field, show the value
      return (
        <p className={classes["Label"]}>
          {props.name}{" "}
          <span className={classes["Data"]}>
            {props.value !== undefined && props.value !== null ? props.value : 0} {/* Show default value if not set */}
          </span>
        </p>
      );
    }

    return (
      <p className={classes["Label"]}>
        {props.name}{" "}
        <span className={classes["Data"]}>
          {props.value || null}
        </span>
      </p>
    );
  };

  return (
    <Col lg={props.lg} md={props.md} className={classes["Col"]}>
      {props.editMode ? (
        <Form layout="vertical">
          <Form.Item
            colon={false}
            style={{ margin: "0", padding: "0" }}
            label={
              <div
                style={{
                  padding: "0rem 0.5rem",
                  fontSize: "0.7rem",
                  fontWeight: "bold",
                }}
                className={classes["Label"]}
              >
                {capitalizeFirstLetter(props.name)}{" "}
                {props.required ? <span style={{ color: "red" }}> *</span> : ""}
            

              </div>
            }
            validateStatus={props.error ? "error" : ""}
            help={props.help || ""}
          >
            {props.type === "Date" ? (
              <DatePicker
                value={props.value ? dayjs(props.value, "DD-MM-YYYY") : null}
                format="DD-MM-YYYY"
                style={{
                  textAlign: "left",
                  width: "100%",
                  backgroundColor: "white",
                  color: "#1777C4",
                  fontWeight: "bold",
                  boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                }}
                bordered={true}
                disabledDate={props.param !== "t_date" ? disabledDate : undefined}
                onChange={(date, dateString) =>
                  props.handleChange(date, dateString, props.param)
                }
              />
            ) : props.type === "Select" ? (
              <Select
                value={props.value || null}
                showSearch
                onChange={(value) => props.handleChange(value, props.param)}
                bordered={true}
                dropdownStyle={{ textTransform: "capitalize" }}
                style={{
                  width: "100%",
                  textAlign: "left",
                  backgroundColor: "white",
                  textTransform: "capitalize",
                  color: "#1777C4",
                  fontWeight: "bold",
                  boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                }}
                placeholder="Search to Select"
              >
                {props.options.rows.map((option) => (
                  <Option
                    key={option[props.options.fields[0].name]}
                    value={option[props.options.fields[0].name]}
                  >
                    {option[props.options.fields[1].name]}
                  </Option>
                ))}
              </Select>
            ) : (
              renderInput()
            )}
          </Form.Item>
        </Form>
      ) : (
        <Card bodyStyle={{ padding: "0.5rem 1rem" }} bordered={false} className={classes["Card"]}>
          {renderCard()}
        </Card>
      )}
    </Col>
  );
};

export default DataField;
